import OrderExportDialog from '../components/OrderExportDialog';
import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import reportService, { saveExportResponse } from '../services/reportService';
import { useT } from '../i18n/LanguageContext';

const reportCards = [
  // The workbook-format export (WQ-260819-01 D): same columns/headers as the master
  // "Order Tracker" sheet, so today's rows paste straight onto the bottom of it.
  { title: 'Daily Order Tracker (Excel)', icon: 'table_view', type: 'tracker', daily: true },
  { title: 'Orders by Date (Excel)', icon: 'date_range', type: 'tracker', custom: true },
  { title: 'All Orders Report', icon: 'assignment', type: 'orders', daily: false },
  { title: 'IVR Reports', icon: 'description', type: 'ivr' },
];

export default function Reports() {
  const t = useT();
  const [exporting, setExporting] = useState(null);

  const [rangeCard, setRangeCard] = useState(null);
  const handleExport = async (card, range = {}) => {
    const key = card.daily ? `${card.type}-daily` : card.type;
    setExporting(key);
    try {
      const params = { ...range };
      if (card.daily) {
        const today = new Date().toISOString().split('T')[0];
        params.dateFrom = today;
        params.dateTo = today;
      }
      const res = await reportService.exportData(card.type, params);
      // EVERY card on this page went out as text/csv named .csv, including the Order Tracker,
      // which the server sends as a real .xlsx workbook. Excel goes by the extension, so the file
      // that download produced was a zip archive called .csv. saveExportResponse reads the
      // server's Content-Type instead, so the CSV cards are unaffected and the workbook arrives
      // as a workbook.
      const prefix = card.daily ? 'daily-' : '';
      saveExportResponse(res, params.dateFrom ? `${prefix}${card.type}-${params.dateFrom}-to-${params.dateTo}` : `${prefix}${card.type}-report-${new Date().toISOString().split('T')[0]}`);
      return true;
    } catch {
      alert(t('Failed to export report'));
      return false;
    } finally {
      setExporting(null);
    }
  };

  return (
    <div>
      {rangeCard && <OrderExportDialog initialDates={{ dateFrom: '', dateTo: '' }} onClose={() => setRangeCard(null)} onExport={range => handleExport(rangeCard, range)} />}
      <PageHeader
        title={t('Reports & Analytics')}
        subtitle={t('Download comprehensive reports.')}
      />

      <div className="flex flex-wrap items-start gap-5">
        {reportCards.map((card) => (
          <div
            key={card.title}
            className="bg-white border border-[#e2e8f0] rounded-[14px] shadow-sm w-[270px] p-5"
          >
            <div className="w-[40px] h-[40px] bg-[#eaf4ff] rounded-[10px] flex items-center justify-center mb-4">
              <span className="material-symbols-outlined text-[#0089ff] text-[24px]">
                {card.icon}
              </span>
            </div>

            <p className="text-[13px] font-semibold text-[#0f172a] leading-[22px] mb-4">
              {t(card.title)}
            </p>

            <button
              onClick={() => card.custom ? setRangeCard(card) : handleExport(card)}
              disabled={exporting === (card.daily ? `${card.type}-daily` : card.type)}
              className="flex items-center gap-1.5 h-[30px] px-3 border border-[#0089ff] rounded-[6px] bg-white hover:bg-[#f0f7ff] transition-colors disabled:opacity-50"
            >
              <span className="material-symbols-outlined text-[#0089ff] text-[20px]">
                {exporting === (card.daily ? `${card.type}-daily` : card.type) ? 'hourglass_empty' : 'download'}
              </span>
              <span className="text-[12px] font-medium text-[#0089ff] leading-[22px]">
                {exporting === (card.daily ? `${card.type}-daily` : card.type) ? t('Exporting...') : t(card.custom ? 'Choose dates' : 'Export')}
              </span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
